// **首页接口列表**

import base from '../base.js'; // 导入接口域名列表
import axios from '../http.js'; // 导入http中创建的axios实例

const index = {
    // 照片墙列表
    photoWallList (params) {
        return axios.get(`${base.bds}/minute/openroom`, {
            params: params
        });
    },
    // // 新闻详情,演示
    // articleDetail (id, params) {
    //     return axios.get(`${base.sq}/topic/${id}`, {
    //         params: params
    //     });
    // },
    // // post提交
    // login (params) {
    //     return axios.post(`${base.sq}/accesstoken`, qs.stringify(params));
    // }
    // // 其他接口…………
}

export default index;



// WEBPACK FOOTER //
// ./src/utils/api/index.js